const en = {
  nav: {
    back: "← Back",
    home: "Go home",
    leaderboard: "Leaderboard",
  },
  brand: {
    name: "🍽 Dream Dinner Party",
  },
  auth: {
    signIn: "Sign in",
    signInWithGoogle: "Sign in with Google",
    signOut: "Sign out",
    signInToVote: "Sign in to vote",
    signInToComment: "Sign in",
    toLeaveAComment: "to leave a comment.",
  },
  errors: {
    partyNotFound: "Party not found",
    userNotFound: "User not found.",
  },
  confirmation: {
    areYouSure: "Are you sure?",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  party: {
    draftNotice: "This party is a draft and not publicly listed",
    by: "by {{name}}",
    byPrefix: "by",
    edit: "Edit",
    unpublish: "Unpublish",
    unpublishing: "Unpublishing…",
    delete: "Delete",
    deleting: "Deleting…",
    ownPartyRestriction: "You can't vote for your own party",
    buildHeading: "Build Your Party",
    editHeading: "Edit Party",
    namePlaceholder: "Name your dinner party…",
    addGuestInstruction: "Click an empty seat to add a celebrity",
    fillAllSeats: "— fill all 6 to publish",
    saveDraft: "Save Draft",
    saving: "Saving…",
    publish: "Publish",
    publishing: "Publishing…",
    publishTooltip: "Fill all 6 seats to publish",
    autosaveSaving: "Saving…",
    autosaveSaved: "Saved",
    duplicateGuest: "That guest is already at the table",
  },
  seats: {
    filled_one: "{{count}} of {{total}} seat filled",
    filled_other: "{{count}} of {{total}} seats filled",
  },
  votes: {
    cast: "Vote for this party",
    remove: "Remove vote",
    updating: "Updating…",
    noRemaining: "No votes remaining",
    earnCredits: "Publish a party to earn +2 votes →",
    label: "votes",
    votersLabel: "People who voted",
    remaining_one: "{{count}} vote remaining",
    remaining_other: "{{count}} votes remaining",
  },
  comments: {
    heading: "Comments",
    reply: "Reply",
    replyPlaceholder: "Reply to {{name}}…",
    edit: "Edit",
    delete: "Delete",
    post: "Post",
    posting: "Posting…",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    characterCount: "{{current}}/{{max}}",
    beFirst: "Be the first to comment.",
    addPlaceholder: "Add a comment…",
  },
  search: {
    heading: "Search celebrities",
    placeholder: "Type a name…",
    loading: "Searching…",
    noResults: "No results found",
    result_one: "{{count}} result",
    result_other: "{{count}} results",
  },
  seat: {
    add: "Add guest",
    empty: "Empty seat",
    remove: "Remove {{name}}",
  },
  table: {
    label: "The Table",
  },
  share: {
    copied: "Link copied!",
    copyLink: "Copy link",
    shareOnX: "Share on X",
    tweetText: "Check out my dream dinner party: {{title}}",
  },
  home: {
    heroTitle: "Who's coming to dinner?",
    heroSubtitle:
      "Build your dream dinner party guest list from the world's most fascinating people.",
    buildParty: "Build a Party →",
    yourParties: "Your parties",
    newParty: "New Party",
    partyLimitReached: "You've reached the 5-party limit",
    noParties: "No parties yet — be the first!",
    viewLeaderboard: "View full leaderboard →",
  },
  leaderboard: {
    heading: "Leaderboard",
    noParties: "No parties yet — be the first!",
    party_one: "{{count}} party",
    party_other: "{{count}} parties",
    previous: "← Previous",
    next: "Next →",
    page: "Page {{page}} of {{total}}",
  },
  profile: {
    published_one: "{{count}} published party",
    published_other: "{{count}} published parties",
    howVotingWorks: "How voting works",
    votingRule1: "· You start with 3 votes to spend on parties you love.",
    votingRule2: "· Publish a party to earn +2 votes.",
    votingRule3: "· Remove a vote to get that credit back.",
    votesUsed: "{{used}} of {{total}} votes used",
    drafts: "Drafts",
    publishedParties: "Published parties",
    parties: "Parties",
    noPublished: "No published parties yet.",
    buildOne: "Build one →",
    votesCast: "Votes cast",
    noVotes: "No votes cast yet.",
    browseParties: "Browse parties →",
  },
  navbar: {
    signedInAs: "signed in as {{name}}",
    voteStats_one: "{{used}} of {{total}} vote used",
    voteStats_other: "{{used}} of {{total}} votes used",
  },
  card: {
    votes: "votes",
    draft: "draft",
    guest_one: "{{count}} guest",
    guest_other: "{{count}} guests",
  },
  source: {
    tmdb: "TMDB",
    comicvine: "Comic Vine",
    wikidata: "Wikidata",
  },
} as const;

export default en;
